var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "307.59 227.02 718.15 879.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-390.033 -691.81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-560.8 -742.345)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-554.001 -786.07)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-365.374 -624.831)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-415.242 -615.529)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-634.626 -624.831)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-576.594 -619.48)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-499.368 -642.616)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-499.368 -602.897)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-507.344 -634.798)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-543.672 -551.115)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-421.348 -531.552)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-383.526 -616.741)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-419.333 -531.955)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-578.209 -531.552)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-616.03 -616.741)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-580.224 -531.955)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-593.7 -457.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-230.694 -321.326)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-314.166 -362.86)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-403.824 -355.236)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-499.58 -413.349)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-528.618 -432.203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-579.905 -431.157)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-631.442 -429.109)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-712.297 -345.26)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-718.474 -423.37)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-329.02 -277.654)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-362.136 -293.323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-373.078 -300.436)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-412.283 -305.226)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-421.613 -277.654)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-454.73 -293.323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-465.253 -293.323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-487.282 -300.436)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-511.424 -300.436)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-538.16 -305.226)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-582.72 -273.574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-595.148 -300.436)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-614.897 -264.16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-633.809 -264.16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-652.3 -293.323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-322.375 -253.285)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-353.964 -223.53)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-391.101 -225.803)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-412.947 -248.915)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-443.53 -248.915)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-501.945 -235.459)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-524.752 -247.561)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-542.01 -248.915)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-579.889 -247.604)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-589.852 -225.497)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-616.022 -247.561)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-627.687 -225.497)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-653.683 -247.561)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-673.692 -248.915)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-271.546 -178.908)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-282.279 -202.067)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-322.654 -182.36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-352.466 -207.213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-385.437 -183.804)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-396.901 -170.937)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-432.361 -206.146)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-448.47 -207.213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-468.219 -207.213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-487.549 -207.213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-507.298 -207.213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-529.326 -200.101)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-551.356 -207.213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-592.255 -185.498)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-619.054 -207.213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-638.153 -207.213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-652.589 -200.101)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-669.451 -202.067)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-685.371 -207.213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "az"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-707.82 -207.213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "aA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-731.96 -207.213)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-113.809 3.1L0 6.199Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 541.732 731.22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-37.902 18.003-53.063 40.745c-15.161 22.741-2.843 26.847 11.371 25.268 14.213-1.58 62.222-26.216 82.437-26.532 20.214-.316 152.239-2.527 152.239-2.527s-11.37-18.003-74.54-30.321c0 0 42.008.315 77.7 21.793 35.69 21.478 57.168 38.218 72.329 35.376 15.161-2.843 18.004-23.373-8.212-47.694-26.216-24.32-66.013-30.005-66.013-30.005l4.106 9.159s1.263 5.685.948 7.58c-.316 1.895-4.107 1.264-4.107 1.264s5.054 3.158 6.633 6.001c0 0-6.001-3.474-10.423-.947 0 0 14.214 3.79 38.534 21.793 24.321 18.004 30.954 22.355 40.114 23.057 0 0-2.843 6.001-34.113-14.213C204.671 19.583 154.767-8.212 77.699.631.632 9.475-44.219 52.115-49.904 52.747-55.59 53.378-38.85 26.215 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 520.044 410.92)",
    clipPath: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-33.164 11.371-121.602 0-121.602 0s18.951-.631 22.109-3.79c0 0-12.949-.947-11.686-2.843C-109.916-8.528-55.987-11.621 0-8.528c0 0-5.053 2.211-7.264 3.791l-21.478.315S-3.474-2.211 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 747.734 343.54)",
    clipPath: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.259.259 0 0 0-.319-.016c-2.776 1.954-5.328 4.173-7.869 6.435-2.497 2.306-4.892 4.741-7.111 7.361-2.194 2.62-4.721 5.145-6.07 8.423-1.35 3.233-2.269 6.802-1.771 10.443a.279.279 0 0 0 .494.137l.006-.009c2.251-2.83 4.014-5.43 5.81-8.104.93-1.316 1.693-2.708 2.462-4.139a31.63 31.63 0 0 1 1.136-2.164c.401-.713.798-1.429 1.246-2.116a95.436 95.436 0 0 1 2.777-4.078 94.927 94.927 0 0 1 2.93-4.014C-4.303 5.483-2.168 2.909.022.372L.027.366A.26.26 0 0 0 0 0m-87.322 23.449c-.902-3.428-3.071-6.265-4.898-9.153-1.851-2.892-3.902-5.624-6.07-8.24-2.218-2.58-4.453-5.118-6.944-7.424a.261.261 0 0 0-.319-.026.259.259 0 0 0-.075.359l.003.006c1.834 2.806 3.608 5.64 5.212 8.555a94.214 94.214 0 0 1 2.371 4.368c.785 1.452 1.506 2.931 2.211 4.411.352.74.651 1.502.954 2.262.313.756.585 1.524.838 2.296.572 1.52 1.144 3.002 1.892 4.429 1.424 2.889 2.826 5.7 4.681 8.804l.006.009c.035.06.092.106.165.125a.277.277 0 0 0 .342-.194c.977-3.543.54-7.203-.369-10.587M8.38-1.401C5.537 11.548-7.413 29.236-16.572 38.08c-9.16 8.844-18.636 3.158-25.584-3.159-6.949-6.317-16.109-5.685-24.637 1.264-8.528 6.949-13.897 10.739-23.689 3.79-9.791-6.949-20.846-36.639-20.846-36.639-2.842-21.162-8.528-40.744-8.528-40.744s99.809 8.528 131.71-1.264c0 0-.631 24.321-3.474 37.271",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 738.668 285.24)",
    clipPath: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.134.113-.266.219-.4.333 0 0 .134-.122.4-.333",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 487.165 500.225)",
    clipPath: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.418-.56-2.902-.899-4.368-1.313-.736-.195-1.489-.307-2.234-.465a29 29 0 0 0-2.248-.388c-3.013-.43-6.064-.593-9.098-.433-3.028.148-6.063.558-8.947 1.496 3.019-.093 5.986-.043 8.945.11 2.954.169 5.896.414 8.807.871 2.917.406 5.815.959 8.685 1.668 2.893.652 5.706 1.576 8.623 2.405C5.614 2.342 2.881.963 0 0m-4.785 4.267c-28.003-7.144-42.561 3.03-45.083 5.036 33.907-28.568 58.745-9.42 79.195.333 20.53 9.791 42.007 6.317 42.007 6.317v6.949C45.119 35.536 26.168 12.163-4.785 4.267",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 553.656 512.628)",
    clipPath: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.134.113.267.219.4.333C.4.333.266.211 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 846.168 500.225)",
    clipPath: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.917-.829 5.73-1.753 8.623-2.405a85.084 85.084 0 0 1 8.685-1.668c2.911-.456 5.852-.701 8.806-.87 2.959-.154 5.927-.203 8.946-.111-2.884-.938-5.919-1.347-8.948-1.496-3.034-.16-6.085.003-9.097.433-.755.096-1.503.233-2.249.388-.745.158-1.497.271-2.234.465-1.466.414-2.949.753-4.367 1.313C5.283-2.987 2.551-1.608 0 0m-63.17 18.951v-6.949s21.478 3.475 42.008-6.316c20.45-9.753 45.288-28.901 79.194-.334C55.511 3.347 40.952-6.828 12.95.316c-30.954 7.896-49.904 31.269-76.12 18.635",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 768.792 507.36)",
    clipPath: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-8.804 11.884L0 23.768l8.805-11.884Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 665.824 476.513)",
    clipPath: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-8.804 11.884L0 23.768l8.805-11.884Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 665.824 529.47)",
    clipPath: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-5.495-3.571-9.949-7.976-9.949-4.404 0-7.975 4.454-7.975 9.949s3.571 9.949 7.975 9.949C-3.571 9.949 0 5.495 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 676.458 486.936)",
    clipPath: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.688-2.073-2.695-1.934-5.376-3.868c-3.598-2.559-7.138-5.193-10.7-7.797-3.533-2.642-7.065-5.286-10.498-8.053-3.447-2.752-6.833-5.577-9.939-8.746 2.586 3.622 5.747 6.8 8.937 9.892 3.229 3.062 6.58 5.986 10.008 8.81 3.408 2.85 6.935 5.544 10.448 8.255a388.21 388.21 0 0 0 5.346 3.96L-4.481.412l2.547 2.007 1.286.99c.417.344.808.719 1.214 1.077l2.417 2.172c.792.738 1.519 1.547 2.283 2.317.751.783 1.529 1.542 2.224 2.378 2.948 3.201 5.512 6.735 8.037 10.302 4.833 7.284 9.002 15.076 12.223 23.337-2.001-8.662-5.629-16.932-10.192-24.634C12.875 12.734 7.116 5.622 0 0m-43.948-7.124c-21.478 5.212-36.086 26.769-36.086 26.769S-62.031-.491-35.973-.491c-1.422-2.132-1.422-3.316-2.842-2.842-1.422.474-5.133-3.791-5.133-3.791m-56.932 58.907 2.842 1.263s25.903-27.797 62.894-30.796l-.829-3.553c-38.392-1.14-64.907 33.086-64.907 33.086m13.547-69.789c-2.076 1.925-4.125 3.866-6.26 5.701l-3.193 2.765-1.652 1.498c-.555.498-1.032 1.049-1.549 1.575-3.992 4.315-7.165 9.154-10.042 14.124-2.832 4.993-5.351 10.153-7.312 15.541 3.106-4.809 6.181-9.583 9.355-14.263 1.637-2.304 3.193-4.658 4.928-6.864.833-1.131 1.717-2.209 2.577-3.311.917-1.04 1.779-2.146 2.757-3.111.478-.492.92-1.033 1.421-1.492l1.487-1.397c1.053-.956 2.173-1.893 3.2-2.896 2.068-2.007 4.114-4.024 6.011-6.178 3.836-4.262 7.423-8.741 10.545-13.551-4.113 3.984-8.163 7.966-12.273 11.859M24.434 56.362C5.482 6.616-26.023 2.826-26.023 2.826c41.455 28.9 47.851 56.379 47.851 56.379-4.265 6.87-15.161 4.264-15.161 4.264l-.237-6.633C-11.1 35.99-32.894 32.437-32.894 32.437c15.162-2.606 28.901 8.054 28.901 8.054-3.79-6.633-17.293-17.056-41.218-10.423-23.926 6.633-51.168 24.636-52.116 25.347-.947.71-3.553 1.185-3.553 1.185l-.237 3.079c7.911.024 7.58 6.633 7.58 6.633s-11.133-3.791-13.976-5.686c-2.843-1.895-6.396-1.184 6.396-30.558S-56.74-16.125-56.74-16.125c-38.534 9.238-60.601 66.802-60.601 66.802l-8.887-9.949c1.422-26.769 13.977-48.562 21.083-55.195 7.107-6.633 15.872-12.318 32.691-26.532 16.819-14.213 20.531-21.319 20.531-21.319-7.66 8.764-33.086 23.214-33.086 23.214 13.029-18.713 38.376-41.455 38.376-41.455 32.217 25.821 40.508 57.09 40.508 57.09-8.055-1.658-27.716-26.294-27.716-26.294C-20.339-26.312 1.692-10.677 1.692-10.677v-5.685C30.593-1.201 38.884 50.914 38.884 50.914z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 724.896 598.514)",
    clipPath: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-5.073-15.331-20.548-26.488-38.855-26.488S-72.647-15.331-77.72 0z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 561.797 624.597)",
    clipPath: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-94.187h-2.066v89.032l-32.708-81.842-1.922.775L-3.234-2.5-2.056.424l1.023-.217z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 511.368 511.012)",
    clipPath: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.901-.806-33.906 80.654-.817 1.932-1.177 2.81.961.403 1.033-.207.196-.041 1.457-3.471z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 559.11 624.06)",
    clipPath: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.072-15.331 20.548-26.488 38.854-26.488C57.161-26.488 72.647-15.331 77.72 0z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 770.945 624.597)",
    clipPath: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-94.187h2.066v89.032l32.708-81.842 1.921.775L3.233-2.5 2.056.424 1.033.207Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 821.374 511.012)",
    clipPath: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 1.9-.806 33.907 80.654.816 1.932 1.178 2.81-.961.403-1.033-.207-.197-.041-1.456-3.471z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 773.631 624.06)",
    clipPath: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 113.809-3.099L0-6.199Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 791.6 722.955)",
    clipPath: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 10.239 98.384c6.256.613 9.385.91 15.644 1.486l-8.252-84.344c10.313.949 15.472 1.398 25.793 2.249l-1.228-13.97A2753.721 2753.721 0 0 1 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 307.592 904.9)",
    clipPath: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a11374.257 11374.257 0 0 0-3.058 40.393c-3.047-13.757-6.118-27.51-9.211-41.259C-7.362-.508-4.908-.335 0 0m16.25 1.061c.97-11.492 1.964-22.982 2.981-34.471-6.59-.398-9.885-.606-16.473-1.044-.677 8.238-1.01 12.356-1.667 20.593a2337.28 2337.28 0 0 1-16.505-1.164 7864.612 7864.612 0 0 0-4.858-21.054c-6.562-.49-9.842-.745-16.4-1.275 2.758 11.7 5.495 23.404 8.21 35.111a10043.9 10043.9 0 0 1 16.413 64.37c8.593.642 12.892.945 21.49 1.516A8661.222 8661.222 0 0 1 16.25 1.061",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 418.888 849.52)",
    clipPath: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c4.739 25.271 9.386 50.553 13.94 75.85 6.349.196 9.523.285 15.872.443a9208.794 9208.794 0 0 0-6.107-34.869 9421.264 9421.264 0 0 0-13.303-63.517c-8.953-.278-13.429-.435-22.379-.785a9880.033 9880.033 0 0 0-6.187 50.242 11000.815 11000.815 0 0 0-10.708-50.955c-8.948-.405-13.421-.626-22.366-1.103a8717.837 8717.837 0 0 0-7.62 62.734 8417.6 8417.6 0 0 0-2.962 34.386c6.319.376 9.478.554 15.798.893a9814.633 9814.633 0 0 1 7.097-74.962c5.119 25.338 10.148 50.69 15.085 76.057 6.234.281 9.351.413 15.587.657A9871.632 9871.632 0 0 1 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 538.432 859.686)",
    clipPath: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 4.391-2.286 6.604-6.861 6.625h-.112c-4.539-.012-6.819-2.24-6.845-6.663l-.341-59.869c-.026-4.423 2.316-6.619 7.026-6.607 4.747.014 7.122 2.222 7.123 6.646zm16.202-59.914c1.34-12.869-10.513-20.049-23.376-20.569-13.801-.559-23.393 8.378-23.197 20.442l.722 59.873c.119 11.652 9.086 21.183 22.773 20.713 12.839-.441 23.797-8.119 22.709-20.589z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 666.107 782.202)",
    clipPath: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c13.583-.146 27.165-.396 40.743-.75l.39-13.925c-10.069.263-15.103.37-25.173.538l.502-28.043c8.761-.146 13.141-.236 21.9-.453l.371-13.974c-8.807.218-13.212.309-22.022.456l.751-41.963c-6.532.108-9.799.153-16.331.223L0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 704.824 757.063)",
    clipPath: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c13.579-.408 27.154-.92 40.723-1.536l.677-13.935c-10.061.457-15.093.661-25.158 1.024l1.082-28.058c8.757-.315 13.135-.49 21.889-.876l.66-13.984c-8.803.388-13.204.564-22.01.881l1.62-41.987c-6.529.235-9.795.343-16.325.539z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 773.207 758.457)",
    clipPath: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c6.276-.311 9.414-.475 15.689-.823l5.815-98.045c-6.523.361-9.785.532-16.31.855L0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 841.923 761.188)",
    clipPath: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.514-12.756-9.003-19.459-21.732-18.952-13.924.555-23.907 9.912-24.735 22.16l-3.885 59.986c-.908 12.209 7.134 20.291 21.147 19.139 13.49-1.109 24.194-9.673 24.232-22.272l1.094-13.214c-6.349.492-9.523.729-15.874 1.184l-1.011 13.208c-.337 4.403-2.787 6.786-7.356 7.135l-.111.008c-4.529.312-6.635-1.758-6.32-6.191l4.264-60.009c.315-4.434 2.823-6.805 7.521-7.129 4.738-.327 6.936 1.718 6.596 6.154l-1.011 13.207c6.437-.462 9.654-.702 16.087-1.201z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 949.73 872.988)",
    clipPath: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2646.75 2646.75 0 0 0 40.594-3.661l1.455-13.99a2217.564 2217.564 0 0 1-25.075 2.336l2.65-28.155c8.73-.772 13.094-1.176 21.817-2.018l1.442-14.039c-8.773.847-13.16 1.253-21.938 2.029l2.651-28.154a2296.057 2296.057 0 0 0 25.78-2.402l1.456-13.991A2752.713 2752.713 0 0 1 8.635-98.24L0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 957.965 768.84)",
    clipPath: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5.92v-5.523c0-1.855.865-2.782 2.594-2.782 1.716 0 2.573.927 2.573 2.782v33.075h5.921V-5.523c0-5.761-2.831-8.641-8.494-8.641C2.838-14.149 0-11.27 0-5.523Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 438.693 963.128)",
    clipPath: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 1.631-.857 2.447-2.573 2.447h-.042c-1.702 0-2.552-.816-2.552-2.447v-22.196c0-1.633.857-2.449 2.573-2.449 1.729 0 2.594.816 2.594 2.449zm5.92-22.196c0-5.078-2.838-7.623-8.514-7.637-5.662 0-8.494 2.545-8.494 7.637V0c0 5.077 2.832 7.615 8.494 7.615C3.082 7.615 5.92 5.077 5.92 0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 482.848 942.236)",
    clipPath: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.355v-5.146H5.92v-10.398h8.118v-5.188H5.92v-10.377h9.435v-5.167H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 497.437 932.752)",
    clipPath: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6.192l-.711-13.64H.711zm-9.038 0h6.193l-.712-13.64h-4.769z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 549.71 926.365)",
    clipPath: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5.92v-5.523c0-1.855.865-2.782 2.594-2.782 1.716 0 2.573.927 2.573 2.782v33.075h5.921V-5.523c0-5.761-2.831-8.641-8.494-8.641C2.838-14.149 0-11.27 0-5.523Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 562.15 963.128)",
    clipPath: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 1.631-.857 2.447-2.573 2.447h-.042c-1.702 0-2.552-.816-2.552-2.447v-22.196c0-1.633.857-2.449 2.573-2.449 1.729 0 2.594.816 2.594 2.449zm5.921-22.196c0-5.078-2.839-7.623-8.515-7.637-5.662 0-8.494 2.545-8.494 7.637V0c0 5.077 2.832 7.615 8.494 7.615 5.676 0 8.515-2.538 8.515-7.615z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 606.307 942.236)",
    clipPath: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 5.077 2.831 7.615 8.494 7.615 5.676 0 8.514-2.538 8.514-7.615v-4.875h-5.92V0c0 1.631-.858 2.447-2.573 2.447h-.042C6.771 2.447 5.92 1.631 5.92 0v-3.285c0-1.618 1.848-3.598 5.544-5.942 3.696-2.329 5.544-5.125 5.544-8.388v-4.581c0-5.092-2.831-7.637-8.493-7.637C2.838-29.819 0-27.274 0-22.196v4.874h5.92v-4.874c0-1.633.865-2.449 2.595-2.449 1.715 0 2.573.816 2.573 2.449v4.141c0 1.758-1.848 3.808-5.544 6.152C1.848-9.576 0-6.744 0-3.41Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 620.337 942.236)",
    clipPath: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.355v-5.146H5.92v-10.398h8.117v-5.188H5.92v-10.377h9.435v-5.167H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 649.71 932.752)",
    clipPath: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.038-14.142L8.075 0h6.276L7.176-20.565l-.167-.46v-15.251H1.088v15.251l-.189.46L-6.276 0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 681.898 932.752)",
    clipPath: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6.192l-.711-13.64H.711zm-9.037 0h6.191l-.71-13.64h-4.77z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 717.547 926.365)",
    clipPath: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.184 31.632h5.982l-1.924-14.56L4.079-9.414h-8.118l-3.074 21.192-3.055-21.192h-8.117l-4.185 26.527-1.924 14.519h5.962L-14.247 0l4.184 31.632h5.878z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 776.96 968.569)",
    clipPath: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.355v-5.146H5.92v-10.398h8.118v-5.188H5.92v-10.377h9.435v-5.167H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 793.53 932.752)",
    clipPath: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v36.276h5.92V5.167h9.435V0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 819.862 981.12)",
    clipPath: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v36.276h5.92V5.167h9.434V0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 845.078 981.12)",
    clipPath: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 5.077 2.831 7.615 8.494 7.615 5.676 0 8.514-2.538 8.514-7.615v-4.875h-5.92V0c0 1.631-.858 2.447-2.573 2.447h-.042c-1.702 0-2.552-.816-2.552-2.447v-3.285c0-1.618 1.848-3.598 5.544-5.942 3.695-2.329 5.543-5.125 5.543-8.388v-4.581c0-5.092-2.831-7.637-8.493-7.637C2.838-29.819 0-27.274 0-22.196v4.874h5.921v-4.874c0-1.633.864-2.449 2.594-2.449 1.715 0 2.573.816 2.573 2.449v4.141c0 1.758-1.849 3.808-5.544 6.152C1.849-9.576 0-6.744 0-3.41Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 869.734 942.236)",
    clipPath: "url(#P)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.068 0 3.852-.292 5.353-.874 1.5-.584 2.649-1.419 3.451-2.513.801-1.092 1.202-2.41 1.202-3.953 0-1.283-.24-2.382-.721-3.299-.481-.918-1.1-1.646-1.857-2.184a6.9 6.9 0 0 0-2.404-1.115c1.515-.204 2.848-.685 3.999-1.441 1.15-.758 2.031-1.72 2.643-2.884.612-1.165.917-2.506.917-4.02 0-1.69-.43-3.161-1.289-4.412-.859-1.253-2.105-2.215-3.735-2.885-1.632-.669-3.583-1.004-5.855-1.004h-4.675c.029.582.044 1.15.044 1.704H.961c1.457 0 2.702.262 3.736.786a5.417 5.417 0 0 1 2.381 2.359c.553 1.049.83 2.331.83 3.845 0 1.515-.277 2.76-.83 3.736-.554.975-1.267 1.733-2.141 2.272a8.885 8.885 0 0 1-2.905 1.136 15.534 15.534 0 0 1-3.124.328v.393c.67 0 1.384.087 2.141.262a6.904 6.904 0 0 1 2.163.917c.684.438 1.237 1.071 1.66 1.902.421.829.633 1.9.633 3.21 0 1.369-.233 2.513-.699 3.43A4.508 4.508 0 0 1 2.731-2.25c-.918.451-2.031.677-3.342.677h-4.544c0 .028-.037.168-.11.415-.072.247-.182.633-.327 1.158Zm-2.578-30.584h-4.063V0h4.063zm-3.932 3.189v-3.189h-3.495l.044.437h.524c.757 0 1.412.269 1.966.809.553.538.83 1.186.83 1.943zm0 24.205h-.131c0 .757-.277 1.405-.83 1.944-.554.539-1.209.809-1.966.809h-.524l-.044.437h3.495z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 429.833 995.62)",
    clipPath: "url(#Q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.039 0 3.859.518 5.461 1.551 1.602 1.034 2.862 2.469 3.78 4.304.917 1.835 1.376 3.976 1.376 6.422 0 2.476-.459 4.624-1.376 6.446-.918 1.819-2.178 3.247-3.78 4.281C3.859 24.038 2.039 24.555 0 24.555c-1.981 0-3.772-.517-5.375-1.551-1.602-1.034-2.869-2.462-3.8-4.281-.933-1.822-1.398-3.97-1.398-6.446 0-2.446.465-4.587 1.398-6.422.931-1.835 2.198-3.27 3.8-4.304C-3.772.518-1.981 0 0 0m0 25.997c2.155 0 4.143-.328 5.964-.983 1.82-.656 3.408-1.588 4.762-2.797a12.808 12.808 0 0 0 3.168-4.325c.757-1.676 1.136-3.547 1.136-5.615 0-2.069-.379-3.939-1.136-5.614a12.788 12.788 0 0 0-3.168-4.325C9.372 1.129 7.784.197 5.964-.458 4.143-1.114 2.155-1.441 0-1.441c-2.126 0-4.093.327-5.898.983-1.807.655-3.394 1.587-4.763 2.796a12.411 12.411 0 0 0-3.167 4.325c-.743 1.675-1.114 3.545-1.114 5.614 0 2.068.371 3.939 1.114 5.615a12.43 12.43 0 0 0 3.167 4.325c1.369 1.209 2.956 2.141 4.763 2.797 1.805.655 3.772.983 5.898.983",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 471.952 1035.293)",
    clipPath: "url(#R)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h4.631c.437-.961.976-1.646 1.617-2.054.64-.408 1.252-.612 1.835-.612h.349v-.437H-1.835v.437h.349c.495 0 .946.233 1.355.7C.276-1.5.32-.846 0 0m-6.423 23.898L5.898-2.84H1.136l-8.913 21.495Zm4.719-18.787h-11.447v1.442h11.447zm-4.719 18.787.262-3.757-9.83-23.113h-2.927l10.311 22.108c.028.058.13.284.306.677A64.78 64.78 0 0 1-7.1 22.718c.189.496.298.889.328 1.18zM-14.768 0c-.321-.846-.277-1.5.131-1.966.408-.467.874-.7 1.399-.7h.349v-.437h-8.476v.437h.349c.583 0 1.194.204 1.835.612.64.408 1.194 1.093 1.66 2.054z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 521.468 1032.263)",
    clipPath: "url(#S)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.311 0 2.519-.146 3.626-.437C4.733-.728 5.694-1.172 6.51-1.77a6.243 6.243 0 0 0 1.901-2.227c.451-.889.677-1.931.677-3.125 0-1.136-.262-2.22-.787-3.254-.524-1.034-1.282-1.9-2.271-2.6-.991-.699-2.157-1.136-3.496-1.311.612-.204 1.267-.67 1.966-1.398.699-.728 1.267-1.427 1.704-2.097.058-.059.262-.343.612-.852.35-.51.793-1.121 1.332-1.835.539-.715 1.085-1.42 1.639-2.119a30.173 30.173 0 0 1 1.638-1.748 5.36 5.36 0 0 1 1.552-1.07c.552-.248 1.193-.372 1.922-.372v-.436h-2.098c-1.602 0-2.926.174-3.975.524-1.049.35-1.923.83-2.622 1.441a11.982 11.982 0 0 0-1.835 2.01c-.175.204-.452.597-.83 1.18a372.196 372.196 0 0 0-2.359 3.67c-.35.554-.568.918-.656 1.093-.524.814-1.114 1.492-1.769 2.031-.655.539-1.333.809-2.031.809v.436a23.11 23.11 0 0 1 2.009 0c.757.029 1.507.109 2.25.241.743.131 1.434.48 2.075 1.048.641.568 1.136 1.464 1.486 2.688.087.261.16.589.218.982.058.393.073.823.044 1.29-.059.902-.233 1.674-.524 2.314a4.4 4.4 0 0 1-1.201 1.595 5.499 5.499 0 0 1-1.705.962 6.997 6.997 0 0 1-2.031.371 66.174 66.174 0 0 1-2.862.022c-.83-.015-1.289-.008-1.376.022-.147.494-.292.99-.437 1.485Zm-4.937-23.418h.131c0-.67.24-1.231.721-1.683a2.434 2.434 0 0 1 1.726-.677h.524l.044-.436h-3.583zm.131-2.796h-3.976V0h3.976zm-3.845 2.796.393-2.796h-3.539v.436h.612c.67 0 1.238.234 1.704.7a2.44 2.44 0 0 1 .743 1.66zm0 20.665h-.087c-.03.67-.278 1.224-.743 1.661-.466.437-1.034.655-1.704.655h-.612V0h3.539z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 550.596 1001.447)",
    clipPath: "url(#T)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.971 0 5.527-.524 7.668-1.573 2.141-1.048 3.786-2.556 4.937-4.522 1.15-1.966 1.726-4.303 1.726-7.012 0-2.708-.576-5.04-1.726-6.991-1.151-1.952-2.796-3.459-4.937-4.522C5.527-25.683 2.971-26.214 0-26.214h-9.438l-.086 1.442h9.35c3.174 0 5.664 1.04 7.47 3.123s2.709 4.93 2.709 8.542c0 3.611-.903 6.459-2.709 8.542C5.49-2.484 3-1.441-.174-1.441h-9.787V0Zm-7.602-26.214h-4.02V0h4.02zm-3.889 2.839v-2.839h-3.145v.436h.567c.67 0 1.245.241 1.726.722.481.48.721 1.04.721 1.681zm-.043 20.579h-.088a2.36 2.36 0 0 1-.765 1.682 2.427 2.427 0 0 1-1.725.677h-.524V0h3.102z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 591.374 1001.447)",
    clipPath: "url(#U)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.218-7.078a13.157 13.157 0 0 0-2.775-3.212c-1.121-.946-2.468-1.697-4.041-2.25-1.573-.553-3.394-.83-5.462-.83-3.204.029-6.036.692-8.498 1.988-2.461 1.295-4.376 3.131-5.745 5.505-1.369 2.374-2.053 5.192-2.053 8.455 0 3.204.677 5.992 2.031 8.366 1.355 2.374 3.262 4.217 5.723 5.527 2.462 1.31 5.381 1.966 8.761 1.966 2.213 0 4.208-.27 5.985-.808 1.777-.539 3.292-1.201 4.544-1.988l.612-6.597h-.393c-.699 2.679-2.003 4.667-3.91 5.963-1.909 1.297-4.129 1.945-6.664 1.945-2.505 0-4.66-.59-6.465-1.77-1.807-1.18-3.205-2.84-4.195-4.981-.99-2.14-1.486-4.668-1.486-7.58 0-2.884.488-5.403 1.464-7.559.975-2.155 2.344-3.837 4.107-5.046 1.761-1.209 3.823-1.842 6.182-1.9 2.126 0 4.034.378 5.724 1.135 1.689.757 3.087 2.003 4.194 3.736C-1.471-5.281-.729-2.943-.35 0z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 669.26 1019.388)",
    clipPath: "url(#V)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-3.583h-.437v.568c0 .845-.248 1.536-.743 2.075-.496.539-1.179.808-2.053.808V0zm-1.966-12.453v-2.927h-.481v.481c0 .669-.197 1.23-.59 1.681-.393.452-.969.678-1.725.678v.087zm0 4.238v-2.927h-2.796v.087c.756 0 1.332.234 1.725.699.393.466.59 1.02.59 1.661v.48zM0 2.053V.917l-4.85.437c.903 0 1.85.079 2.84.24.99.16 1.659.312 2.01.459m2.445-20.054-2.139-6.86h-6.947l1.442 1.486c1.368 0 2.512.225 3.429.677a6.295 6.295 0 0 1 2.293 1.9 10.578 10.578 0 0 1 1.486 2.797zm-2.577-5.374.307-1.486h-11.622v1.486zM-1.966-12.54h-9.481v1.485h9.481zM0-.132h-11.447v1.485H0Zm-11.359-24.729h-3.976V1.353h3.976zm-3.889 2.796.48-2.796h-3.626v.437h.612c.699 0 1.273.233 1.725.699.453.466.692 1.019.722 1.66zm0 20.666h-.087c-.03.67-.269 1.224-.722 1.66-.452.438-1.026.656-1.725.656h-.612v.437h3.626z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 699.67 1003.251)",
    clipPath: "url(#W)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.311 0 2.519-.146 3.626-.437C4.732-.728 5.694-1.172 6.51-1.77a6.243 6.243 0 0 0 1.901-2.227c.45-.889.676-1.931.676-3.125 0-1.136-.261-2.22-.786-3.254a7.07 7.07 0 0 0-2.272-2.6c-.991-.699-2.155-1.136-3.495-1.311.612-.204 1.267-.67 1.966-1.398.699-.728 1.268-1.427 1.704-2.097.058-.059.263-.343.611-.852.35-.51.794-1.121 1.333-1.835.54-.715 1.085-1.42 1.639-2.119a29.493 29.493 0 0 1 1.638-1.748c.48-.467.997-.823 1.552-1.07.552-.248 1.193-.372 1.922-.372v-.436h-2.098c-1.602 0-2.927.174-3.975.524-1.05.35-1.924.83-2.622 1.441a12.032 12.032 0 0 0-1.836 2.01c-.174.204-.451.597-.829 1.18-.38.582-.78 1.202-1.201 1.857-.423.656-.809 1.259-1.158 1.813-.35.554-.569.918-.657 1.093-.523.814-1.113 1.492-1.769 2.031-.654.539-1.332.809-2.03.809v.436a23.086 23.086 0 0 1 2.008 0c.758.029 1.508.109 2.25.241.744.131 1.435.48 2.076 1.048.64.568 1.136 1.464 1.485 2.688a6.283 6.283 0 0 1 .263 2.272c-.058.902-.234 1.674-.524 2.314A4.403 4.403 0 0 1 3.08-2.862a5.483 5.483 0 0 1-1.704.962 7.004 7.004 0 0 1-2.032.371 66.154 66.154 0 0 1-2.862.022c-.83-.015-1.289-.008-1.376.022L-5.33 0Zm-4.937-23.418h.13c0-.67.242-1.231.722-1.683a2.434 2.434 0 0 1 1.726-.677h.523l.045-.436h-3.584zm.13-2.796h-3.976V0h3.976zm-3.844 2.796.393-2.796h-3.539v.436h.611c.67 0 1.239.234 1.706.7.464.466.712 1.019.742 1.66zm0 20.665h-.087c-.03.67-.278 1.224-.742 1.661-.467.437-1.036.655-1.706.655h-.611V0h3.539z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 722.68 1001.447)",
    clipPath: "url(#X)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-3.539h-.479v.568c0 .845-.249 1.529-.744 2.054-.496.524-1.179.8-2.053.83V0Zm0 2.054V.917l-4.805.437c.552 0 1.157.036 1.813.11.655.072 1.252.167 1.791.284.539.115.939.218 1.201.306m-10.354-24.162h.131c0-.641.246-1.194.743-1.66a2.465 2.465 0 0 1 1.748-.699h.48v-.437h-3.102zm.131-2.796h-4.02V1.179h4.02zm-3.932 2.796v-2.796h-3.103v.437h.525c.67 0 1.245.233 1.726.699.481.466.736 1.019.765 1.66zM-21.189 0v-.087c-.874-.03-1.56-.306-2.054-.83-.496-.525-.742-1.209-.742-2.054v-.568h-.481V0ZM0-.087h-24.466v1.442H0Zm-24.466 2.141c.261-.088.662-.191 1.201-.306a17.484 17.484 0 0 1 1.791-.284c.656-.074 1.26-.11 1.814-.11l-4.806-.437z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 773.185 1003.194)",
    clipPath: "url(#Y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.13c.028-.641.312-1.194.852-1.66.539-.466 1.202-.699 1.989-.699h.523l.045-.437H0Zm0 20.623v2.795h3.539l-.045-.436h-.523c-.787 0-1.45-.226-1.989-.677-.54-.452-.824-1.013-.852-1.682ZM.13-2.796h-3.932v26.214H.13ZM-3.671 0v-2.796H-7.21v.437h.612c.756 0 1.405.233 1.944.699.539.466.823 1.019.852 1.66zm0 20.623h-.131c-.029.669-.313 1.23-.852 1.682-.539.451-1.201.677-1.988.677h-.568v.436h3.539z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 786.469 1032.671)",
    clipPath: "url(#Z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-3.583h-.481v.568c0 .845-.248 1.536-.742 2.075-.496.539-1.179.808-2.053.808V0Zm-2.054-12.453v-2.927h-.48v.481c0 .669-.19 1.23-.568 1.681-.378.452-.961.678-1.748.678v.087zm0 4.238v-2.927H-4.85v.087c.787 0 1.37.234 1.748.699.378.466.568 1.02.568 1.661v.48zM0 2.053V.917l-4.894.437c.582 0 1.203.036 1.857.109.656.073 1.26.167 1.814.284.552.116.96.219 1.223.306M-2.054-12.54h-9.568v1.485h9.568zM0-.132h-11.622v1.485H0Zm-11.622-21.933h.088a2.422 2.422 0 0 1 .742-1.66c.465-.466 1.063-.699 1.792-.699h.567v-.437h-3.627zm.088-2.796h-3.933V1.353h3.933zm-3.845 2.796.437-2.796h-3.627v.437h.612c.699 0 1.281.233 1.747.699.466.466.714 1.019.743 1.66zm0 20.666h-.088c-.029.67-.277 1.224-.743 1.66-.466.438-1.048.656-1.747.656h-.612v.437h3.627z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 821.362 1003.251)",
    clipPath: "url(#aa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.131c.027-.641.311-1.194.851-1.66.539-.466 1.202-.699 1.989-.699h.523l.045-.437H0Zm0 20.623v2.795h3.539l-.045-.436h-.523c-.787 0-1.45-.226-1.989-.677-.54-.452-.824-1.013-.851-1.682ZM.131-2.796h-3.933v26.214H.131ZM-3.671 0v-2.796H-7.21v.437h.612c.756 0 1.405.233 1.944.699.539.466.823 1.019.852 1.66zm0 20.623h-.131c-.029.669-.313 1.23-.852 1.682-.539.451-1.201.677-1.988.677h-.568v.436h3.539z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 836.915 1032.671)",
    clipPath: "url(#ab)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-3.583h-.437v.568c0 .845-.249 1.536-.743 2.075-.496.539-1.179.808-2.053.808V0zm-1.967-12.453v-2.927h-.48v.481c0 .669-.197 1.23-.59 1.681-.394.452-.968.678-1.726.678v.087zm0 4.238v-2.927h-2.796v.087c.758 0 1.332.234 1.726.699.393.466.59 1.02.59 1.661v.48zM0 2.053V.917l-4.85.437c.903 0 1.85.079 2.84.24.989.16 1.66.312 2.01.459m2.446-20.054-2.14-6.86h-6.947l1.441 1.486c1.369 0 2.513.225 3.43.677a6.299 6.299 0 0 1 2.294 1.9 10.666 10.666 0 0 1 1.486 2.797zm-2.577-5.374.306-1.486h-11.622v1.486zM-1.967-12.54h-9.48v1.485h9.48zM0-.132h-11.447v1.485H0Zm-11.359-24.729h-3.977V1.353h3.977zm-3.89 2.796.481-2.796h-3.627v.437h.613c.699 0 1.274.233 1.725.699.452.466.692 1.019.721 1.66zm0 20.666h-.087c-.029.67-.269 1.224-.721 1.66-.451.438-1.026.656-1.725.656h-.613v.437h3.627z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 871.577 1003.251)",
    clipPath: "url(#ac)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.971 0 5.527-.524 7.668-1.573 2.142-1.048 3.786-2.556 4.936-4.522 1.152-1.966 1.727-4.303 1.727-7.012 0-2.708-.575-5.04-1.727-6.991-1.15-1.952-2.794-3.459-4.936-4.522C5.527-25.683 2.971-26.214 0-26.214h-9.438l-.086 1.442h9.349c3.175 0 5.665 1.04 7.472 3.123 1.806 2.083 2.709 4.93 2.709 8.542 0 3.611-.903 6.459-2.709 8.542C5.49-2.484 3-1.441-.175-1.441h-9.786V0Zm-7.602-26.214h-4.021V0h4.021zm-3.889 2.839v-2.839h-3.146v.436h.569c.67 0 1.245.241 1.726.722.481.48.72 1.04.72 1.681zm-.043 20.579h-.088a2.353 2.353 0 0 1-.765 1.682 2.426 2.426 0 0 1-1.724.677h-.526V0h3.103z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 898.257 1001.447)",
    clipPath: "url(#ad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-5.746-2.838-8.626-8.515-8.64-5.662 0-8.494 2.88-8.494 8.64v25.105c0 5.746 2.832 8.619 8.494 8.619 5.677 0 8.515-2.873 8.515-8.619v-5.523h-5.92v5.523c0 1.841-.858 2.768-2.574 2.782h-.042c-1.701 0-2.552-.927-2.552-2.782V0c0-1.855.858-2.782 2.573-2.782 1.73 0 2.595.927 2.595 2.782v5.523H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 362.062 1094.79)",
    clipPath: "url(#ae)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-10.397h1.359c.824 0 1.388.048 1.695.147 1.074.375 1.611 1.15 1.611 2.321v5.439C4.665-.83 3.807 0 2.092 0Zm-5.921 5.146h8.619c5.258 0 7.887-2.544 7.887-7.636v-5.439c0-3.194-1.555-5.3-4.665-6.318l6.653-16.882H6.088L.753-15.167 0-15.272v-15.857h-5.921z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 376.372 1063.91)",
    clipPath: "url(#af)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.304 207.213h5.92v-36.276h-5.92z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 0 1333.333)",
    clipPath: "url(#ag)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 6.883 24.853h5.921v-36.276h-5.67V8.933L2.072-11.423h-4.017l-5.21 20.356v-20.356h-5.732v36.276h5.921z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 430.206 1090.186)",
    clipPath: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.002 207.213h5.92v-36.276h-5.92z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 0 1333.333)",
    clipPath: "url(#ai)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5.92l5.607-21.046V0h5.481v-36.276h-5.921L5.69-15.899v-20.377H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 469.955 1057.049)",
    clipPath: "url(#aj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.259 15.104L-4.519 0Zm5.983 0 1.925-12.866H1.925L.774-5.167h-6.046l-1.171-7.699h-5.963l1.925 12.824 4.184 23.452H1.82Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 513.916 1088.262)",
    clipPath: "url(#ak)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v36.276h5.92V5.167h9.435V0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 529.202 1105.417)",
    clipPath: "url(#al)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-29.372h2.594c1.715 0 2.573.927 2.573 2.783v23.786C5.167-.934 4.309 0 2.594 0Zm-5.921 5.837h9.122c5.257-.014 7.886-2.894 7.886-8.64v-23.786c0-5.733-2.754-8.605-8.263-8.619h-8.745z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 576.482 1058.472)",
    clipPath: "url(#am)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.356v-5.146H5.921v-10.398h8.117v-5.187H5.921v-10.378h9.435v-5.167H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 597.96 1057.049)",
    clipPath: "url(#an)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.355v-5.146H5.92v-10.398h8.118v-5.187H5.92v-15.545H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 624.292 1057.049)",
    clipPath: "url(#ao)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.355v-5.146H5.92v-10.398h8.118v-5.187H5.92v-10.378h9.435v-5.167H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 650.065 1057.049)",
    clipPath: "url(#ap)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5.92l5.606-21.046V0h5.482v-36.276h-5.921L5.69-15.899v-20.377H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 676.397 1057.049)",
    clipPath: "url(#aq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 5.076 2.831 7.615 8.494 7.615 5.676 0 8.514-2.539 8.514-7.615v-4.875h-5.92V0c0 1.631-.859 2.447-2.573 2.447h-.042c-1.702 0-2.552-.816-2.552-2.447v-3.285c0-1.619 1.847-3.599 5.544-5.942 3.695-2.329 5.543-5.125 5.543-8.388v-4.582c0-5.091-2.831-7.636-8.493-7.636C2.838-29.819 0-27.274 0-22.197v4.874h5.921v-4.874c0-1.632.864-2.448 2.594-2.448 1.714 0 2.573.816 2.573 2.448v4.142c0 1.758-1.849 3.808-5.544 6.151C1.848-9.576 0-6.745 0-3.411Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 705.768 1066.532)",
    clipPath: "url(#ar)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.354v-5.146H5.92v-10.398h8.117v-5.187H5.92v-10.378h9.434v-5.167H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 735.142 1057.049)",
    clipPath: "url(#as)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.259 17.072L-4.519 0Zm5.983 0 1.926-14.56H1.925L.774-5.857h-6.045l-1.172-8.703h-5.962l1.924 14.498 4.184 26.547H1.82Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 789.673 1086.003)",
    clipPath: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-5.146h-5.543v-31.13h-5.921v31.13h-5.544V0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 825.405 1057.049)",
    clipPath: "url(#au)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-5.146h-5.543v-31.13h-5.921v31.13h-5.544V0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 850.871 1057.049)",
    clipPath: "url(#av)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 1.631-.857 2.447-2.573 2.447h-.042c-1.701 0-2.552-.816-2.552-2.447v-22.197c0-1.632.857-2.448 2.573-2.448 1.729 0 2.594.816 2.594 2.448zm5.92-22.197c0-5.077-2.838-7.622-8.514-7.636-5.663 0-8.494 2.545-8.494 7.636V0c0 5.076 2.831 7.615 8.494 7.615C3.082 7.615 5.92 5.076 5.92 0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 870.119 1066.532)",
    clipPath: "url(#aw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-10.397h1.36c.823 0 1.387.048 1.694.147 1.074.375 1.611 1.15 1.611 2.321v5.439C4.665-.83 3.807 0 2.093 0Zm-5.92 5.146h8.618c5.258 0 7.888-2.544 7.888-7.636v-5.439c0-3.194-1.556-5.3-4.666-6.318l6.653-16.882H6.088L.753-15.167 0-15.272v-15.857h-5.92z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 892.602 1063.91)",
    clipPath: "url(#ax)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5.921l5.606-21.046V0h5.482v-36.276h-5.921L5.69-15.899v-20.377H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 913.828 1057.049)",
    clipPath: "url(#ay)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.354v-5.146H5.92v-10.398h8.117v-5.187H5.92v-10.378h9.434v-5.167H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 943.76 1057.049)",
    clipPath: "url(#az)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.038-14.142L8.075 0h6.277L7.177-20.565l-.168-.46v-15.251H1.088v15.251l-.188.46L-6.275 0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 975.947 1057.049)",
    clipPath: "url(#aA)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogoWhite);
export default __webpack_public_path__ + "static/media/FullLogoWhite.2f2b69e6415419e09a2d43f92d5e859c.svg";
export { ForwardRef as ReactComponent };